export const STRIPE_BUY_URL =
  process.env.REACT_APP_STRIPE_BUY_URL ||
  "https://buy.stripe.com/test_9AQbKnfOkgtKbg4288";

// Cloud Function endpoint that creates a Stripe Checkout Session.
// Empty string => modal falls back to STRIPE_BUY_URL (no bonus, no preview).
export const CREATE_CHECKOUT_URL =
  process.env.REACT_APP_CREATE_CHECKOUT_URL || "";

export const GET_STATS_URL =
  process.env.REACT_APP_GET_STATS_URL ||
  (CREATE_CHECKOUT_URL
    ? CREATE_CHECKOUT_URL.replace(/\/createCheckoutSession\/?$/, "/getStats")
    : "");

// Cloud Function endpoint that emails the sponsor inquiry to the club inbox.
// Empty string => the SponsorModal falls back to a mailto: link.
export const SEND_SPONSOR_INQUIRY_URL =
  process.env.REACT_APP_SEND_SPONSOR_INQUIRY_URL ||
  (CREATE_CHECKOUT_URL
    ? CREATE_CHECKOUT_URL.replace(
        /\/createCheckoutSession\/?$/,
        "/sendSponsorInquiry"
      )
    : "");

export const DONATION_GOAL_DUCKS = 10000;

export const RACE_DATE_ISO =
  process.env.REACT_APP_RACE_DATE || "2026-06-01T17:00:00+03:00";

export const RACE_YEAR = 2026;
export const RACE_DATE_LABEL = "1 iunie 2026 · ora 17:00";
export const RACE_EDITION = "Ediția a XVII-a";
export const RACE_CITY = "Timișoara";
export const RACE_ROUTE = "Podul Mihai Viteazu → Podul Maria";

export const PRICE_PER_DUCK_RON = 10;
